import { UsersQueryApi } from '@lib/api/endpoints';
import type { AuthUserSession, GoogleAuthUserSession } from '@lib/types/authUser.types';

const ADMIN_ROLES = ['admin'];

const extractCastifiUserId = (
  authUser: AuthUserSession | GoogleAuthUserSession
): string | undefined => {
  // Try to get from attributes (AuthUserSession)
  const attrId = authUser?.attributes?.['custom:castifi_user_id'];
  if (attrId && typeof attrId === 'string' && attrId.trim() !== '') {
    return attrId;
  }

  // Try to get from idToken payload (GoogleAuthUserSession)
  const tokenId = authUser?.signInUserSession?.idToken?.payload?.['custom:castifi_user_id'];
  if (tokenId && typeof tokenId === 'string' && tokenId.trim() !== '') {
    return tokenId;
  }

  return undefined;
};

export const isAuthUserAdmin = async (
  authUser: AuthUserSession | GoogleAuthUserSession
): Promise<boolean> => {
  try {
    const currentUserIdRaw = extractCastifiUserId(authUser);
    if (!currentUserIdRaw) {
      return false;
    }

    const currentUserId = Number(currentUserIdRaw);
    if (Number.isNaN(currentUserId)) {
      return false;
    }

    const impersonatedUser = await UsersQueryApi.getUser(currentUserId);
    if (
      !impersonatedUser ||
      typeof impersonatedUser.casting_role !== 'string' ||
      !ADMIN_ROLES.includes(impersonatedUser.casting_role)
    ) {
      return false;
    }

    return true;
  } catch (error) {
    console.error('Error checking admin status:', error);
    return false;
  }
};
